export const formControlsNames = [
  "businessName",
  "ownerName",
  "name",
  "documentType",
  "documentCategory",
  "dateOfFiling",
  "filingEndDate",
  "filingStartDate",
  "streetAddress",
  "city",
  "state",
  "receivedByDate",
  "filingNumber",
  "businessId",
  "expirationDate",
  "expirationStartDate",
  "expirationEndDate",
  "incorporator",
  "comissionNumber",
  "registrationNumber",
  "secRegistrationNumber",
  "dealerId",
  "dealerType",
  "county",
  "issueDate",
  "issueEndDate",
  "issueStartDate",
];

export const DOCUMENT_DETAIL_KEY_LABEL_MAPPING = {
  businessName: "Business/Company Name",
  ownerName: "Owner/Individual Name",
  name: "File Name",
  documentType: "Document Type",
  dateOfFiling: "Date of Filing",
  filingEndDate: "Filing Date End",
  filingStartDate: "Filing Date Start",
  streetAddress: "Street Address",
  city: "City",
  state: "State",
  receivedByDate: "Received By Date",
  filingNumber: "Filing Number",
  businessId: "Business ID",
  expirationDate: "Expiration Date",
  newExpirationDate: "New Expiration Date",
  currentExpirationDate: "Current Expiration Date",
  expirationStartDate: "Expiration Date Start",
  expirationEndDate: "Expiration Date End",
  incorporator: "Incorporator",
  comissionNumber: "Commission #",
  registrationNumber: "Registration Number",
  secRegistrationNumber: "SEC Registration Number",
  dealerId: "Dealer ID",
  dealerType: "Dealer Type",
  county: "County",
  issueDate: "Issue Date",
  issueEndDate: "Issue Date End",
  issueStartDate: "Issue Date Start",
};
